import App from '../../../app/browser/App';
// eslint-disable-next-line import/first
import createRoutes from 'search-ion/lib/modules/routes/createRoutesBuilder';

export default createRoutes(App);



// WEBPACK FOOTER //
// ./src/ions/search/browser/createRoutes.js